import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';
import { decrypt, encrypt } from '../utils/crypt';
import { authReducer, AuthReducerInitialState } from './reducers/auth.reducer';
import { settingsReducer, SettingsReducerInitialState } from './reducers/settings.reducer';

export interface AppState {
  auth: AuthReducerInitialState;
  settings: SettingsReducerInitialState;
}

export const reducers: ActionReducerMap<AppState> = {
  auth: authReducer,
  settings: settingsReducer,
};

export function localStorageSyncReducer(reducer: ActionReducer<AppState>): ActionReducer<AppState> {
  return localStorageSync({
    keys: [
      {
        settings: {
          encrypt: (state) => encrypt(state),
          decrypt: (state) => decrypt(state),
        },
      },
      {
        auth: {
          encrypt: (state) => encrypt(state),
          decrypt: (state) => decrypt(state),
        },
      },
    ],
    rehydrate: true,
    storage: typeof window !== 'undefined' ? localStorage : undefined,
  })(reducer);
}

export const metaReducers: MetaReducer<AppState>[] =
  typeof window === 'undefined' ? [] : [localStorageSyncReducer];
